'use client'
import * as React from 'react'
import { useIsMounted } from 'hooks/use-is-mounted'
import { useTranslations } from 'next-intl'
import { useCookies } from 'react-cookie'
import invariant from 'tiny-invariant'
import { useUserLocation } from 'hooks/use-user-location'

import { GDPR_COOKIE_NAME } from './constants'
import { tw } from 'utils/classnames'
import { Z_INDEX_MODALS } from 'constants/modals'

import { getCookieDomain } from 'utils/env'

const cookieDomain = process.env.NEXT_PUBLIC_COOKIE_DOMAIN || process.env.VITE_COOKIE_DOMAIN
invariant(cookieDomain, 'Cookie domain is not defined inside gdpr')

export const GDPRConsent = () => {
  const t = useTranslations('gdpr')
  const [cookies, setCookie] = useCookies([GDPR_COOKIE_NAME])
  const [isOpen, setIsOpen] = React.useState(!cookies[GDPR_COOKIE_NAME])
  const isConsentAccepted = !isOpen
  const isMounted = useIsMounted()
  const { isUserFromEUOrUK } = useUserLocation()

  if (!isMounted || isConsentAccepted || !isUserFromEUOrUK) {
    return null
  }

  const handleConsent = () => {
    const expires = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365 * 10) // 10 years
    setCookie(GDPR_COOKIE_NAME, 1, {
      path: '/',
      expires,
      domain: getCookieDomain(cookieDomain),
    })
    setIsOpen(false)
  }

  return (
    <div
      className={tw(
        'bg-primary-500 text-cf-white',
        'animate-fade-in text-14 fixed bottom-0 mb-4 p-4',
        'left-[calc(50%+var(--removed-body-scroll-bar-size)/2)] w-[calc(100%-2*8px-var(--removed-body-scroll-bar-size))] -translate-x-[calc(50%+var(--removed-body-scroll-bar-size))] md:max-w-md',
      )}
      style={{
        zIndex: Z_INDEX_MODALS.gdpr.react,
      }}
    >
      <button onClick={handleConsent} className="absolute right-2 top-2">
        X
      </button>
      {t('site_cookie_consent')}{' '}
      <a
        href="https://www.iubenda.com/privacy-policy/24976076/cookie-policy"
        color="inherit"
        className="underline"
      >
        {t('site_cookie_consent_policy')}
      </a>
    </div>
  )
}
